import React from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { IState } from '../../store/models/IState';
import { ITimesheetState } from '../../store/models/ITimesheetState';
import { UpsertType } from '../../store/models/UpsertType';
import TimesheetEntryForm from './TimesheetEntryForm';

export type TimesheetModalProps = {
    show?: boolean;
    onHide?: () => void;
}

/**
 * Allows inserting/updating an item.
 * @param props Determines whether to display the dialog and what to do when closing the dialog.
 */
const TimesheetModal: React.FC<TimesheetModalProps> = (props) => {
    const timesheetState: ITimesheetState = useSelector((state: IState) => state.timesheetState);
    const upsertType: string = timesheetState?.selectedItem ? UpsertType.Update : UpsertType.Insert

    /**
     * Upsert the inserted/updated employee and close the dialog.
     */
    function okButtonClick(): void {
        // TODO: Call the form OkButtonClick.
        closeModal();
    }

    /**
     * Close the modal.
     */
    function closeModal(): void {
        if (props.onHide) {
            props.onHide();
        }
    }

    return (
        <Modal id="item-modal" show={props.show} onHide={closeModal} className="" size="xl" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {upsertType} Item
                </Modal.Title>
            </Modal.Header>
            <TimesheetEntryForm isModal={true} onOkButtonClick={okButtonClick} onCancelButtonClick={closeModal} />
        </Modal>
    );
}

export default TimesheetModal;
